import axios from "axios";
import { ANALYTICS_REPORT_FAILURE, ANALYTICS_REPORT_SUCCESS } from "./analytics.actionTypes";
import { GET_ANALYTICS_REPORT } from "../../utils/api";
import { apiRequest } from "../../api/apiRequest";

// export const analyticsReport = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(GET_ANALYTICS_REPORT, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: ANALYTICS_REPORT_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: ANALYTICS_REPORT_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: ANALYTICS_REPORT_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };


export const analyticsReport = () => async (dispatch) => {
  const result = await apiRequest("get", GET_ANALYTICS_REPORT);

  if (result.success) {
    dispatch({
      type: ANALYTICS_REPORT_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: ANALYTICS_REPORT_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};